module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/4-11432153ded31247bc5c6909c2ac6857.jpg";